/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".splash-container[_ngcontent-%COMP%]{height:100%;width:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.splash-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:256px;height:auto}"];
export { styles as styles };
